// extracted by mini-css-extract-plugin
export default {"tabViewWrapper":"TicketProcessingReview_tabViewWrapper__2EZkD","emptyContainer":"TicketProcessingReview_emptyContainer__3-Va1"};